import { Module } from "vuex";
import * as NS from './namespace';
import getters from './getters';

/**
 * Состояние по умолчанию общих настроек
 */
const defaultState: NS.IAppState = {
    appName: 'Экологический контроль',
    shortAppName: 'E-Co',
    copyright: '© Центр лесной пирологии, 2020',
    copyrightLink: 'http://firescience.ru',
    devLink: 'https://incom.tomsk.ru/',
};

/**
 * Модуль общих настроек приложения
 */
export const AppModule: Module<NS.IAppState, NS.IAppState> = {
    namespaced: true,
    getters: {
        ...getters,
    },
    state: {
        ...defaultState,
    },
};
